import { render } from "./Picture.vue?vue&type=template&id=d077aa9c"
import script from "./Picture.vue?vue&type=script&lang=js"
export * from "./Picture.vue?vue&type=script&lang=js"
script.render = render

export default script